import { useState } from "react";
import { Download, FileText, Send, X, Loader2 } from "lucide-react";
import { toast } from "sonner";

import { BACKEND } from "../lib/backend";

/**
 * Modal that previews + downloads + (future) emails the generated offer PDF.
 * `SEND_EMAIL_ENABLED` is backend-flagged; UI shows the button disabled with
 * tooltip when false.
 */
export default function PdfPreviewModal({ offerId, offerNumber, onClose }) {
  const [url] = useState(
    `${BACKEND}/api/offers/${offerId}/pdf?t=${Date.now()}`
  );
  const [loading, setLoading] = useState(true);

  return (
    <div
      className="fixed inset-0 z-[60] flex items-center justify-center p-4"
      style={{ background: "rgba(0,0,0,0.55)" }}
      onClick={onClose}
      data-testid="pdf-preview-modal"
    >
      <div
        className="w-full max-w-4xl h-[85vh] rounded-xl p-4 flex flex-col"
        style={{
          background: "var(--bg-surface)",
          border: "1px solid var(--border-subtle)",
        }}
        onClick={(e) => e.stopPropagation()}
      >
        <div className="flex items-center justify-between mb-3">
          <div className="flex items-center gap-2">
            <FileText className="h-4 w-4" style={{ color: "var(--accent-primary)" }} />
            <div
              className="font-semibold text-[14px]"
              style={{ color: "var(--text-primary)" }}
            >
              Anteprima offerta {offerNumber || ""}
            </div>
          </div>
          <button
            type="button"
            onClick={onClose}
            className="h-7 w-7 rounded flex items-center justify-center"
            style={{ color: "var(--text-muted)" }}
            data-testid="pdf-close"
          >
            <X className="h-4 w-4" />
          </button>
        </div>
        <div
          className="flex-1 rounded overflow-hidden relative"
          style={{ border: "1px solid var(--border-subtle)", background: "#F3F4F6" }}
        >
          {loading && (
            <div className="absolute inset-0 flex items-center justify-center">
              <Loader2 className="h-5 w-5 animate-spin" style={{ color: "var(--text-muted)" }} />
            </div>
          )}
          <iframe
            src={url}
            title="Anteprima PDF"
            className="w-full h-full border-0"
            onLoad={() => setLoading(false)}
            data-testid="pdf-iframe"
          />
        </div>
        <div className="mt-3 flex items-center gap-2">
          <a
            href={url}
            download={`offerta_${offerNumber || offerId}.pdf`}
            className="inline-flex items-center gap-1.5 h-9 px-3 rounded-md text-[13px] font-medium"
            style={{
              background: "var(--accent-primary)",
              color: "var(--text-on-accent)",
            }}
            data-testid="pdf-download"
          >
            <Download className="h-3.5 w-3.5" />
            Scarica PDF
          </a>
          <button
            type="button"
            disabled
            title="Invio email: SEND_EMAIL_ENABLED non attivo"
            className="inline-flex items-center gap-1.5 h-9 px-3 rounded-md text-[13px] font-medium opacity-50 cursor-not-allowed"
            style={{
              background: "var(--bg-subtle)",
              color: "var(--text-muted)",
              border: "1px solid var(--border-default)",
            }}
            onClick={() => toast.info("Invio email non ancora attivo")}
            data-testid="pdf-send-email"
          >
            <Send className="h-3.5 w-3.5" />
            Invia al cliente
          </button>
          <div
            className="ml-auto text-[11px]"
            style={{ color: "var(--text-muted)" }}
          >
            Il PDF viene rigenerato ad ogni click: le modifiche alla scrivania
            sono sempre riflesse.
          </div>
        </div>
      </div>
    </div>
  );
}
